// Generated by CoffeeScript 1.11.1
(function() {
  var FillOpacity, LayerInfo,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  LayerInfo = require('../layer_info');

  module.exports = FillOpacity = (function(superClass) {
    extend(FillOpacity, superClass);

    function FillOpacity() {
      return FillOpacity.__super__.constructor.apply(this, arguments);
    }

    FillOpacity.shouldParse = function(key) {
      return key === 'iOpa';
    };

    FillOpacity.prototype.parse = function() {
      return this.value = this.file.readByte();
    };

    return FillOpacity;

  })(LayerInfo);

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/layer_info/fill_opacity.js
// module id = 58
// module chunks = 0